<template>
  <div class="related-to-page">
    <ul>
      <li :class="{ active: isActive('/fatherline/overview') }">
        <router-link to="/fatherline/overview">Overview</router-link>
      </li>
      <li :class="{ active: isActive('/fatherline/history') }">
        <router-link to="/fatherline/history">History</router-link>
      </li>
      <li :class="{ active: isActive('/fatherline/distribution-map') }">
        <router-link to="/fatherline/distribution-map">Distribution Map</router-link>
      </li>
      <li :class="{ active: isActive('/fatherline/migration-map') }">
        <router-link to="/fatherline/migration-map">Migration Map</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "FatherLineNavigation",
  computed: {
    // Access the current route
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    // Determine if the route matches the current path
    isActive(path) {
      return this.currentRoute === path;
    },
  },
};
</script>
